import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

export default function WhyManifesto() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section aria-label="Manifesto" className="min-h-[60vh] flex items-center bg-bg py-24">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
        >
          {/* Eyebrow */}
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="w-8 h-px bg-stroke"></div>
            <span className="text-xs text-muted uppercase tracking-[0.3em]">Dlaczego to robię</span>
            <div className="w-8 h-px bg-stroke"></div>
          </div>

          {/* Pull quote */}
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-display italic text-text-primary leading-tight mb-8">
            "Małe firmy tracą setki tysięcy rocznie nie dlatego że są złe - dlatego że ich systemy są <span className="bg-gradient-to-r from-accent-from to-accent-to bg-clip-text text-transparent">ręczne</span>. Naprawiam to."
          </h2>

          {/* Sub paragraph */}
          <p className="text-lg text-muted max-w-md mx-auto leading-relaxed mb-6">
            W każdej firmie B2B z którą pracowałem, 60-80% pracy operacyjnej to powtarzalne taski które mogłyby działać same. To nie magic - to systemy. Buduję je tak, żebyś sam mógł je rozumieć i kontrolować.
          </p>

          {/* Signature */}
          <div className="text-sm text-muted font-medium">
            - Dawid Stępień, Founder DAIEN
          </div>
        </motion.div>
      </div>
    </section>
  );
}
